import { showError } from './showError';

export const sendUpdateTrackRequest = async (
  orderid,
  trackingId,
  trackingLink,
) => {
  try {
    if (!trackingId || !trackingLink)
      showError('Tracking Link or Id is missing!', '0px');
    else {
      const res = await axios({
        method: 'POST',
        url: '/api/v1/orders/updatetracking',
        data: {
          orderid,
          trackingId,
          trackingLink,
        },
      });

      if (res.data.status === 'success')
        window.setTimeout(() => location.assign('/admin/orders'), 1500);
    }
  } catch (error) {
    showError(error.response.data.message, '0px');
  }
};

export const sendDeliveryStatus = async (orderid) => {
  try {
    if (!orderid) showError('Order id is missing!', '0px');
    else {
      const res = await axios({
        method: 'POST',
        url: '/api/v1/orders/updatedelivery',
        data: {
          orderid,
        },
      });

      if (res.data.status === 'success')
        window.setTimeout(() => location.assign('/admin/orders'), 1500);
    }
  } catch (error) {
    showError(error.response.data.message, '0px');
  }
};
